import type { StatsEqualizerResponse } from "@/domains/validators"

import type { ScaleStatsStoreDAO } from "./types"

/**
 * Convert API response to Store DAO format
 * Maps complex nested API structure to flattened DAO with simplified naming
 */
export function convertApiResponseToScaleStatsStoreDAO(apiResponse: StatsEqualizerResponse): ScaleStatsStoreDAO {
  const result = {
    // Incentives data (flattened from history object with simplified names)
    totalIncentives: apiResponse.history.current.totalIncentives,
    incentivesPerVote: apiResponse.history.current.incentivesPerVote,
    totalIncentivesLastEpoch: apiResponse.history.lastEpoch.totalIncentives,
    incentivesPerVoteLastEpoch: apiResponse.history.lastEpoch.incentivesPerVote,

    // Basic stats (direct mapping)
    blockTimestamp: apiResponse.blockTimestamp,
    price: apiResponse.price,
    priceFtm: apiResponse.priceFtm,
    priceInFtm: apiResponse.priceInFtm,

    // Supply data (direct mapping)
    circulatingSupply: apiResponse.circulatingSupply,
    outstandingSupply: apiResponse.outstandingSupply,
    dilutedSupply: apiResponse.dilutedSupply,
    inNFT: apiResponse.inNFT,
    inGauges: apiResponse.inGauges,
    inExcluded: apiResponse.inExcluded,
    veTotalSupply: apiResponse.veEqualTotalSupply,

    // Financial metrics (direct mapping)
    lockRatio: apiResponse.lockRatio,
    liquidity: apiResponse.liquidity,
    circulatingMarketCap: apiResponse.circulatingMarketCap,
    marketCap: apiResponse.marketCap,
    fdv: apiResponse.fdv,
    lockedMarketCap: apiResponse.lockedMarketCap,
    totalTvl: apiResponse.totalTvl,

    // Ecosystem data (flattened from ecosystem object)
    ecosystemNumTokens: apiResponse.ecosystem.numTokens,
    ecosystemNumPairs: apiResponse.ecosystem.numPairs,
    ecosystemNumGauges: apiResponse.ecosystem.numGauges,
  }
  return result
}
